module.exports = "\n<banner></banner>\n<product-home></product-home>\n<gallery></gallery>\n<!-- <about-us></about-us> -->\n<contact-us></contact-us>"